import { PaymentMethod } from '../Types';

export function isBoletoMethod(tipoMetodo: string): boolean {
  return tipoMetodo === 'boleto';
}

export function getPrimeiroVencimento(method: PaymentMethod): string | null {
  const cfg = method.configuracaoEspecifica;
  if (!cfg || typeof cfg !== 'object') return null;

  const raw =
    cfg.primeiroVencimento ??
    cfg.dataPrimeiroVencimento ??
    cfg.primeiro_vencimento ??
    cfg.data_primeiro_vencimento;

  if (!raw) return null;

  const str = String(raw).trim();
  if (!str) return null;

  const dateOnly = str.includes('T') ? str.split('T')[0] : str.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return null;

  const parsed = new Date(`${dateOnly}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return null;

  return dateOnly;
}
